// assets/cpv1-atc.js
(function () {
  if (window.__cpv1AtcInitialised) return;
  window.__cpv1AtcInitialised = true;

  function updateCartCounts(count) {
    const cartLink = document.getElementById('cart-icon-bubble');
    let bubbles = document.querySelectorAll('.cart-count-bubble');

    if (bubbles.length === 0 && cartLink) {
      const bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      cartLink.appendChild(bubble);
      bubbles = document.querySelectorAll('.cart-count-bubble');
    }

    bubbles.forEach(bubble => {
      bubble.removeAttribute('hidden');
      bubble.style.display = '';
      const visual = bubble.querySelector('span[aria-hidden="true"]');
      if (visual) visual.textContent = count;
      const sr = bubble.querySelector('span.visually-hidden');
      if (sr) sr.textContent = count === 1 ? '1 item' : `${count} items`;
    });
  }

  function dispatchCartEvents(cart) {
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
      window.dispatchEvent(new CustomEvent('theme:cart:updated', { detail: cart }));
    } catch (e) {
      console.warn('Could not dispatch cart events', e);
    }
  }

  function refreshCartDrawerAndOpen() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return Promise.resolve();

    return fetch('/?section_id=cart-drawer')
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartDrawer = doc.querySelector('cart-drawer');

        if (newCartDrawer) {
          const currentInner = cartDrawer.querySelector('.drawer__inner');
          const newInner = newCartDrawer.querySelector('.drawer__inner');
          if (currentInner && newInner) currentInner.innerHTML = newInner.innerHTML;
          cartDrawer.classList.remove('is-empty');
        }

        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          const drawerEl = cartDrawer.querySelector('#CartDrawer');
          if (drawerEl) drawerEl.classList.add('active');
        }
      })
      .catch(err => console.error('Error refreshing cart drawer:', err));
  }

  async function addItemToCart(variantId, quantity) {
    const resp = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    });

    if (!resp.ok) {
      const txt = await resp.text().catch(() => null);
      throw new Error(`Failed to add variant ${variantId}: ${resp.status} ${txt || ''}`);
    }
    return resp.json();
  }

  document.addEventListener('click', async function (e) {
    const button = e.target.closest('.cpv1-atc-btn');
    if (!button || button.disabled) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = parseInt(button.dataset.variantId, 10);
    if (!variantId) {
      alert('No variant linked to this product.');
      return;
    }

    const labelEl = button.querySelector('.cpv1-atc-label');
    const originalText = labelEl ? labelEl.textContent : button.textContent;

    button.disabled = true;
    if (labelEl) labelEl.textContent = 'Adding...';
    else button.textContent = 'Adding...';

    try {
      await addItemToCart(variantId, 1);

      if (labelEl) labelEl.textContent = '✓ Added!';
      else button.textContent = '✓ Added!';

      const cartResp = await fetch('/cart.js');
      if (!cartResp.ok) throw new Error('Failed to fetch cart');
      const cart = await cartResp.json();

      await refreshCartDrawerAndOpen();
      dispatchCartEvents(cart);
      setTimeout(() => updateCartCounts(cart.item_count || 0), 300);

      setTimeout(() => {
        if (labelEl) labelEl.textContent = originalText;
        else button.textContent = originalText;
        button.disabled = false;
      }, 1500);

    } catch (error) {
      console.error('Error adding to cart:', error);
      if (labelEl) labelEl.textContent = 'Error – Try again';
      else button.textContent = 'Error – Try again';
      button.disabled = false;
      setTimeout(() => {
        if (labelEl) labelEl.textContent = originalText;
        else button.textContent = originalText;
      }, 2000);
    }
  });
})();